import React, { Component } from 'react';

import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import Toolbar from '@material-ui/core/Toolbar';
import MenuIcon from '@material-ui/icons/Menu';

import { IMAGES } from '../Images';

import './Header.css';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerOpen: false,
    };
    this.PageRoutes = [
      {
        id: 1,
        routeName: 'home',
        pageUrl: '/',
      },
      {
        id: 2,
        routeName: 'about us',
        pageUrl: '/about-us',
      },
      {
        id: 3,
        routeName: 'core team',
        pageUrl: '/core-team',
      },
      {
        id: 4,
        routeName: 'projects',
        pageUrl: '/projects',
      },
      {
        id: 5,
        routeName: 'clients',
        pageUrl: '/clients',
      },
      {
        id: 6,
        routeName: 'contact us',
        pageUrl: '/contact-us',
      },
    ];
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setState({ drawerOpen: false });
    }
  }

  navigateTo = (route) => {
    this.props.history.push(route);
    this.toggleDrawer(false);
  };

  toggleDrawer = (toggle) => {
    this.setState({ drawerOpen: toggle });
  };
  render() {
    return (
      <>
        <AppBar position="static" color="default">
          <Toolbar className="header-toolbar">
            <div className="header-logo-container">
              <img src={IMAGES.LOGO_LIGHT} alt="logo" />
            </div>
            <div className="header-links-container">
              {this.PageRoutes.map((pr) => {
                return (
                  <Button
                    key={pr.id}
                    color="primary"
                    size="large"
                    className={`btn ${this.props.history.location.pathname === pr.pageUrl ? 'active' : ''}`}
                    onClick={() => this.navigateTo(pr.pageUrl)}
                    style={{ fontSize: '1.1rem' }}>
                    {pr.routeName}
                  </Button>
                );
              })}
            </div>
            <div className="header-menu-bar">
              <MenuIcon fontSize="large" onClick={() => this.toggleDrawer(true)} />
            </div>
            <Drawer anchor="right" open={this.state.drawerOpen} onClose={(e) => this.toggleDrawer(false)}>
              <div className="drawer-wrapper">
                <div className="drawer-content">
                  <img src={IMAGES.LOGO_LIGHT} alt="logo" />
                  {this.PageRoutes.map((pr) => {
                    return (
                      <Button
                        key={pr.id}
                        color="primary"
                        className={`btn ${this.props.history.location.pathname === pr.pageUrl ? 'active' : ''}`}
                        onClick={() => this.navigateTo(pr.pageUrl)}
                        style={{ fontSize: '1.1rem' }}>
                        {pr.routeName}
                      </Button>
                    );
                  })}
                </div>
              </div>
            </Drawer>
          </Toolbar>
        </AppBar>
        <>{this.props.children}</>
      </>
    );
  }
}
export default withRouter(Header);
